export const chartColors = ["#d0c6dd","#b0a1c6","#917baf","#8268a4","#725599","#63438e","#593c7f","#4f3571","#452e63","#3b2855"];
